<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div class="noAlTope" v-if="cargando">
      <b-button variant="primary" disabled>
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>
    </div>

    <b-form class="mt-4" v-on:submit.prevent="validarDatos" v-else>
      <div class="text-left">
        <b-row>
          <b-col>
            <label>Cuenta: *</label>
            <b-form-select
              v-model="cuenta"
              :options="listaCuentas"
              value-field="idCuenta"
              text-field="nombreBanco"
              :state="cuenta != null"
              v-on:change="traerCuentasClinicas"
              required
            >
            </b-form-select>
            <b-form-invalid-feedback :state="cuenta != null">
              Seleccione una opción
            </b-form-invalid-feedback>
          </b-col>
          <b-col v-if="mostrarEditar">
            <label>Cambiar cuenta: </label>
            <b-form-input
              v-model.trim="cuentaNueva"
              maxlength="14"
              placeholder="Cuenta: "
            >
            </b-form-input>
          </b-col>
        </b-row>

        <div v-if="mostrarEditar">
          <label class="mt-4">Clínica: *</label>
          <v-select
            v-model="clinicaActuales"
            :options="listaClinicas"
            label="strNombre"
            id="idClinica"
            :reduce="(variable) => variable.idClinica"
            :state="clinicaActuales.length != 0"
            multiple
          />
          <b-form-invalid-feedback :state="clinicaActuales.length != 0">
            Seleccione una opción
          </b-form-invalid-feedback>
        </div>

        <div v-else>
          <label class="mt-4">Clínica: *</label>
          <v-select
            v-model="clinica"
            :options="listaClinicas"
            label="strNombre"
            id="idClinica"
            :reduce="(variable) => variable.idClinica"
            :state="clinica.length != 0"
            multiple
          />
          <b-form-invalid-feedback :state="clinica.length != 0">
            Seleccione una opción
          </b-form-invalid-feedback>
        </div>
      </div>

      <b-button
        class="mt-4"
        type="submit"
        variant="outline-primary"
        v-if="!enviando"
      >
        Guardar
      </b-button>

      <b-button class="mt-4" variant="primary" v-else disabled>
        <b-spinner small></b-spinner>
        Cargando...
      </b-button>
    </b-form>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";

export default {
  name: "AltaCuentasClinica",
  props: {
    mostrarEditar: Boolean,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    listaCuentas: [],
    listaClinicas: [],
    cuenta: null,
    clinica: [],
    clinicaActuales: [],
    cuentaNueva: "",
    cargando: true,
    enviando: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.traerClinicas();
    this.traerCuentas();
  },
  methods: {
    traerCuentas() {
      const urlCuenta = this.$api + "catalogos/listaCuentaBancaria";
      this.$http
        .get(urlCuenta)
        .then((response) => {
          if (response.status === 200) {
            let lista = [];
            response.data.data.forEach((cuenta) => {
              let contenido = {
                idCuenta: cuenta.idCuenta,
                nombreBanco: cuenta.nombreBanco + " " + cuenta.numeroCuenta,
              };

              lista.push(contenido);
            });
            this.listaCuentas = lista;
          }
        })
        .catch((err) => {
          this.errorMensaje(err);
        });
    },
    traerClinicas() {
      const urlClinica = this.$api + "catalogos/listaClinicas";
      this.$http
        .get(urlClinica)
        .then((response) => {
          if (response.status === 200) {
            let lista = [];
            response.data.data.forEach((element) => {
              let contenido = {
                strNombre: element.strNombre,
                idClinica: element.idClinica,
              };
              lista.push(contenido);
            });
            this.listaClinicas = lista;
            this.cargando = false;
          }
        })
        .catch((err) => {
          this.cargando = false;
          this.errorMensaje(err);
        });
    },
    traerCuentasClinicas() {
      if (this.mostrarEditar) {
        this.cargando = true;
        const url =
          this.$api + "cuenta/bancaria/clinica?idCuenta=" + this.cuenta;
        this.$http.get(url).then((response) => {
          if (response.status === 200) {
            this.clinicaActuales = response.data.data.listaClinicas;
            this.cuentaNueva = response.data.data.numeroCuenta;
            this.cargando = false;
          }
        });
      }
    },
    validarDatos() {
      if (this.clinica.length == 0 && !this.mostrarEditar) {
        this.$swal({
          icon: "warning",
          text: "Debe seleccionar una clínica",
          confirmButtonText: "OK",
          confirmButtonColor: "#0e6ba9",
        });
      } else {
        this.$swal({
          icon: "question",
          text: "La lista es correcta?",
          confirmButtonColor: "#0e6ba9",
          cancelButtonColor: "#8e8e8e",
          confirmButtonText: "Guardar",
          cancelButtonText: "Cancelar",
          showCancelButton: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.enviando = true;

            if (this.mostrarEditar) {
              this.editarCuenta();
            } else {
              this.guardarCuentas();
            }
          }
        });
      }
    },
    guardarCuentas() {
      const urlCuentas = this.$api + "cuenta/bancaria/clinica";

      this.$http
        .post(urlCuentas, this.traerDatos())
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Se envio la información correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
            this.enviando = false;
          }
        })
        .catch((err) => {
          this.enviando = false;
          this.errorEnvio(err);
        });
    },
    editarCuenta() {
      const urlCuentas = this.$api + "cuenta/bancaria/clinica";
      this.$http
        .put(urlCuentas, this.traerDatosEditar())
        .then((response) => {
          if (response.status === 200) {
            this.$swal({
              icon: "success",
              text: "Se envio la información correctamente",
              confirmButtonText: "OK",
              confirmButtonColor: "#0e6ba9",
            });
            this.enviando = false;
          }
        })
        .catch((err) => {
          this.enviando = false;
          this.errorEnvio(err);
        });
    },
    traerDatosEditar() {
      return {
        idCuenta: this.cuenta,
        numeroCuenta: this.cuentaNueva,
        listaClinica: this.clinicaActuales,
        usuarioLogeado: this.$localStorageService.getIdUsuario(),
      };
    },
    traerDatos() {
      return {
        idCuenta: this.cuenta,
        listaClinica: this.clinica,
        usuarioLogeado: this.$localStorageService.getIdUsuario(),
      };
    },
  },
  notifications: {
    errorMensaje: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
    errorEnvio: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al enviar la información",
    },
  },
};
</script>